/* AYB · Müşteri yorumları — sayfa sayfa kayan ray.
 *
 * Ray CSS ile zaten yatay kaydırılabilir; bu dosya sadece okları ve
 * benekleri ekliyor. JS çalışmazsa gezinti hiç çizilmiyor (bölümdeki
 * hidden kalkmıyor) — çalışmayan ok göstermek yerine ray parmakla/
 * touchpad ile kaydırılabilir halde bırakılıyor.
 *
 * Sayfa sayısı kart genişliğinden ÖLÇÜLEREK bulunuyor, medya sorgusuyla
 * tekrar tanımlanmıyor: kaç kart sığdığını CSS belirliyor (--ayb-yo-adet)
 * ve iki yerde ayrı ayrı sayı tutmak ikisinin kaçınılmaz olarak
 * birbirinden ayrılması demek.
 */
(function () {
  function az() {
    return window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function kur(kasa) {
    if (kasa.dataset.aybYoHazir) return;
    kasa.dataset.aybYoHazir = '1';

    var ray = kasa.querySelector('[data-ayb-yo-ray]');
    if (!ray) return;

    var kok = kasa.closest('.ayb-yorumlar') || kasa.parentNode;
    var gezinti = kok.querySelector('[data-ayb-yo-gezinti]');
    var benekKap = kok.querySelector('[data-ayb-yo-benek]');
    var geri = kok.querySelector('[data-ayb-yo-geri]');
    var ileri = kok.querySelector('[data-ayb-yo-ileri]');
    if (!gezinti || !benekKap) return;

    var kartlar = [].slice.call(ray.children);
    if (!kartlar.length) return;

    var sayfa = 0;
    var sayfaSayisi = 1;

    function adet() {
      // Kaç kart sığıyor: ray genişliği / (kart genişliği + boşluk)
      var k = kartlar[0].getBoundingClientRect().width;
      if (!k) return 1;
      var bosluk = parseFloat(getComputedStyle(ray).columnGap || getComputedStyle(ray).gap) || 0;
      var n = Math.round((ray.clientWidth + bosluk) / (k + bosluk));
      return Math.max(1, Math.min(n, kartlar.length));
    }

    function benekleriCiz() {
      benekKap.innerHTML = '';
      for (var i = 0; i < sayfaSayisi; i++) {
        var d = document.createElement('button');
        d.type = 'button';
        d.setAttribute('role', 'tab');
        d.setAttribute('aria-selected', i === sayfa ? 'true' : 'false');
        d.setAttribute('aria-label', (i + 1) + ' / ' + sayfaSayisi);
        d.dataset.aybYoSayfa = String(i);
        benekKap.appendChild(d);
      }
    }

    function isaretle() {
      var benekler = benekKap.children;
      for (var i = 0; i < benekler.length; i++) {
        benekler[i].setAttribute('aria-selected', i === sayfa ? 'true' : 'false');
      }
      if (geri) geri.disabled = sayfa <= 0;
      if (ileri) ileri.disabled = sayfa >= sayfaSayisi - 1;
    }

    function git(n, kaydir) {
      sayfa = Math.max(0, Math.min(n, sayfaSayisi - 1));
      if (kaydir) {
        var n_adet = adet();
        var hedef = kartlar[Math.min(sayfa * n_adet, kartlar.length - 1)];
        // scrollLeft ile: scrollIntoView sayfanın kendisini de kaydırıyor
        var x = hedef.offsetLeft - ray.offsetLeft;
        if (ray.scrollTo) ray.scrollTo({ left: x, behavior: az() ? 'auto' : 'smooth' });
        else ray.scrollLeft = x;
      }
      isaretle();
    }

    function olc() {
      var n = adet();
      var yeni = Math.ceil(kartlar.length / n);
      if (yeni !== sayfaSayisi) {
        sayfaSayisi = yeni;
        if (sayfa > sayfaSayisi - 1) sayfa = sayfaSayisi - 1;
        benekleriCiz();
      }
      gezinti.hidden = sayfaSayisi <= 1;
      isaretle();
    }

    // Kaydırma elle yapıldığında da benek doğru kalsın
    var bekliyor = false;
    ray.addEventListener('scroll', function () {
      if (bekliyor) return;
      bekliyor = true;
      setTimeout(function () {
        bekliyor = false;
        var n = adet();
        var k = kartlar[0].getBoundingClientRect().width;
        var bosluk = parseFloat(getComputedStyle(ray).columnGap || getComputedStyle(ray).gap) || 0;
        var birim = (k + bosluk) * n;
        if (birim > 0) {
          /* Son sayfa tam kaydirilamiyor: ray icerigi ekrandan tasan
             miktarla sinirli. Orn. 7 kart / 3'lu gorunumde ucuncu sayfa
             2880 yerine 1921'de duruyor ve scrollLeft/birim 1.33 cikip
             ikinci benegi yakiyordu. Sona degdiysek son sayfadayiz. */
          var enCok = ray.scrollWidth - ray.clientWidth;
          var y = (enCok - ray.scrollLeft < 4) ? sayfaSayisi - 1
                                               : Math.round(ray.scrollLeft / birim);
          if (y !== sayfa) { sayfa = Math.max(0, Math.min(y, sayfaSayisi - 1)); isaretle(); }
        }
      }, 120);
    }, { passive: true });

    if (geri) geri.addEventListener('click', function () { git(sayfa - 1, true); });
    if (ileri) ileri.addEventListener('click', function () { git(sayfa + 1, true); });

    benekKap.addEventListener('click', function (e) {
      var d = e.target.closest('[data-ayb-yo-sayfa]');
      if (d) git(parseInt(d.dataset.aybYoSayfa, 10), true);
    });

    // Ok tuşlarıyla gezinme: benek şeridi odakta olduğunda
    benekKap.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); git(sayfa + 1, true); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); git(sayfa - 1, true); }
    });

    window.addEventListener('resize', olc, { passive: true });
    olc();

    // Ölçüm yazı tipi/görsel yüklenmesiyle değişebiliyor
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(olc);

    kasa.aybYoOlc = olc;                       // sınama ve yeniden ölçüm için
  }

  function tara() {
    document.querySelectorAll('[data-ayb-yorumlar]').forEach(kur);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tara);
  } else {
    tara();
  }
  document.addEventListener('shopify:section:load', tara);
})();
